import { TemplateFilterParams } from "@/types/FilterParams.interface"
import Template from "@/types/Template.interface"

interface State {
    templatesViewTemplates: Template[]
    templatesViewDefaultParams: TemplateFilterParams
    templatesViewParams: TemplateFilterParams
}

const defaults = () => {
    return {
        templatesViewTemplates: [],
        templatesViewDefaultParams: {
            display: 'Newest to Oldest',
            key: 'sort',
            value: 'desc'
        },
        templatesViewParams: {
            display: 'Newest to Oldest',
            key: 'sort',
            value: 'desc'
        }
    }
}

export default {
    state: defaults(),
    mutations: {
        templatesViewParamsSet (state: State, params: TemplateFilterParams): void {
            state.templatesViewParams = params
        },
        templatesViewTemplatesPush (state: State, templates: Template[]): void {
            //  Update our state
            state.templatesViewTemplates = window.removeDuplicatesById(state.templatesViewTemplates, templates)
        },
        templatesViewTemplatesRemove (state: State, ids: number[]): void {
            //  Get our current list of templates
            const templates = state.templatesViewTemplates

            //  If no templates, do nothing
            if (!templates) return

            //  Else filter out the removed ids
            const filtered = templates.filter((x: Template) => !ids.includes(x.id))

            //  Replace our templates list with the filtered list
            state.templatesViewTemplates = filtered
        },
        templatesViewTemplatesSet (state: State, templates: Template[]): void {
            state.templatesViewTemplates = templates
        },
        templatesViewReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
    },
    getters: {
        templatesViewTemplates (state: State): Template[] {
            return state.templatesViewTemplates
        },
        templatesViewDefaultParams (state: State): TemplateFilterParams {
            return state.templatesViewDefaultParams
        },
        templatesViewParams (state: State): TemplateFilterParams {
            return state.templatesViewParams
        }
    }
}
